import React from "react";
import UserDefaultAvatar from "assets/img/user.svg";

const PollAvatars = ({ users }) => {
  return (
    <div className="pollAvatars">
      {users?.map((item, index) => (
        <span className="pollAvatar" key={index}>
          <img
            src={item.avatar ?? UserDefaultAvatar}
            alt={item.full_name}
            title={item.full_name || ""}
          />
        </span>
      ))}
    </div>
  );
};
export default PollAvatars;
